import { HOME_WIDGETS_PRIORITY } from '../../../components/widgets/homeWidgets/constants';
import type { HomeWidgetsPriority } from '../../../components/widgets/homeWidgets/types';
import { FREE_SPIN_PROVIDERS, HOME_WIDGET_WIDGET_TYPE_MAPPING } from '../constants';
import type { SortHomeWidgetType, Widget } from '../types';

const sortWidgetsByWeight = (a: SortHomeWidgetType, b: SortHomeWidgetType) => {
  const orderA = a.weight || 0;
  const orderB = b.weight || 0;
  if (orderA < orderB) {
    return 1;
  } else if (orderA > orderB) {
    return -1;
  } else {
    return 0;
  }
};

const sortHomeWidgets = (widgetsList: SortHomeWidgetType[], priority?: HomeWidgetsPriority) => {
  const widgetsPriority = priority ?? HOME_WIDGETS_PRIORITY;

  return [...widgetsList].sort((a, b) => {
    const orderA = widgetsPriority[a.type];
    const orderB = widgetsPriority[b.type];
    if (orderA < orderB) {
      return -1;
    } else if (orderA > orderB) {
      return 1;
    } else {
      return sortWidgetsByWeight(a, b);
    }
  });
};

export const sortWidgets = (widgets: Widget[], homeWidgetsOrder?: HomeWidgetsPriority): Widget[] => {
  const widgetsMap = new Map<string, Widget>();
  const bingoWidgets: Widget[] = [];
  // TODO(crown-rips): crownRips isn't in HOME_WIDGET_WIDGET_TYPE_MAPPING / home_widgets_order, so —
  // like bingo — it's injected manually here instead of being filtered out. It's pinned to the very
  // front of the row (before bingo) while the kill switch is on. Migrate it into the home-widgets
  // ordering config once it needs a configurable position, and remove this.
  const crownRipsWidgets: Widget[] = [];

  widgets.forEach((widget) => {
    widgetsMap.set(widget.id, widget);
    if (widget.type === 'bingo') {
      bingoWidgets.push(widget);
    }
    if (widget.type === 'crownRips') {
      crownRipsWidgets.push(widget);
    }
  });

  const sortTypedWidgets: SortHomeWidgetType[] = [];
  widgets.forEach((widget) => {
    const type = HOME_WIDGET_WIDGET_TYPE_MAPPING[widget.type];

    if (type && widget.type !== 'bingo' && widget.type !== 'crownRips') {
      sortTypedWidgets.push({
        id: widget.id,
        type,
        weight: widget.data.weight,
      });
    }
  });

  const sortedHomeWidgets = sortHomeWidgets(sortTypedWidgets, homeWidgetsOrder);
  const sortedResult: Widget[] = [];

  // Crown Rips is pinned first (ahead of bingo) whenever it's present.
  crownRipsWidgets.forEach((widget) => {
    sortedResult.push(widget);
  });

  bingoWidgets.forEach((widget) => {
    sortedResult.push(widget);
  });

  sortedHomeWidgets.forEach((widget) => {
    const item = widgetsMap.get(widget.id);
    if (item) {
      sortedResult.push(item);
    }
  });
  return sortedResult;
};

export const isFreeSpinMiniGame = (provider: string) => {
  return [FREE_SPIN_PROVIDERS.BAROULETTA, FREE_SPIN_PROVIDERS.MINIGAMES].includes(provider);
};
